import React, {useEffect} from 'react';
import {
    ExpansionPanelDetailsUnstyled,
    ExpansionPanelSummaryUnstyled,
    ExpansionPanelUnstyled
} from "../../../AccordionComponent/ExpansionWrapper";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core";
import ScriptType from "../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType";
const useStyles = makeStyles(() => ({
    panelDetails: {
        padding: '0',
        display: 'block'
    }
}))
const PointsScript = ({onChangeFields, question}) => {
    const [expanded, setExpanded] = React.useState(false);

    useEffect(() => {
        if(question.pointsScript) {
            setExpanded(true)
        }
    }, []);

    const classes = useStyles();
    return (
        <ExpansionPanelUnstyled style={{width: '100%'}}
                                TransitionProps={{
                                    unmountOnExit: true
                                }}
                                expanded={expanded}
        >
            <ExpansionPanelSummaryUnstyled
                expandIcon={<ExpandMoreIcon/>}
                onClick={() => setExpanded(prev => !prev)}
            >
                <Typography style={{width: 130}}>Points Script</Typography>
            </ExpansionPanelSummaryUnstyled>
            <ExpansionPanelDetailsUnstyled classes={{root: classes.panelDetails}}>
                <div style={{
                    padding: "0px 10px"
                }}>
                    <ScriptType
                        values={question}
                        setValue={onChangeFields}
                        field={{
                            path: `pointsScript`,
                            label: "Points Script",
                        }}
                        fieldStyles={{
                            width: 350,
                            fullWidth: true,
                            hideLabel: true
                        }}
                        labelStyles={{width: 130}}
                    />
                </div>
            </ExpansionPanelDetailsUnstyled>
        </ExpansionPanelUnstyled>
    )
}

export default PointsScript;